
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-video",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-video"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{staticClass:"i-video__reels"},[_c('circle',{attrs:{"cx":"5.09","cy":"5.42","r":"2.28"}}),_c('circle',{attrs:{"cx":"11.05","cy":"5.42","r":"2.28"}})]),_c('path',{staticClass:"i-video__lense",attrs:{"d":"M15.34 14.43V9.71L12.53 11V9.38H3.52v5.47h9.01v-1.56l2.81 1.14z"}})])
          )
        }
      }
    